<div class="head">
  <div class="icon-name">
    <div *ngIf="icon" class="icon" margin-right-small-x>
      <rt-icon [name]="icon" size="small"></rt-icon>
    </div>
    <div class="name">{{ name }}</div>
  </div>
  <div *ngIf="remove.observers.length && !removable" (click)="remove.emit()" class="close-button">
    <rt-icon name="close" size="small-x"></rt-icon>
  </div>
</div>
<ng-container
  [ngTemplateOutlet]="contentTemplate"
  [ngTemplateOutletContext]="contentTemplateContext"
></ng-container>
